/**
 * Lens registry — pluggable `(node, ctx) → decoration` functions.
 *
 * Callers (ExplorerViewService) resolve a lens id to a definition via
 * `getLens(id)` and invoke `decorate`. Renderers branch on the stamped
 * `attrs.lens` only, never on the lens id — strategy-pattern clean.
 *
 * New lenses register via `registerLens`. Barrel `index.ts` triggers
 * registration for built-ins.
 */

import type { LensDefinition } from '../models/explorer/ExplorerLens';

class LensRegistryImpl {
  private readonly lenses = new Map<string, LensDefinition>();

  register(lens: LensDefinition): void {
    this.lenses.set(lens.id, lens);
  }

  unregister(id: string): void {
    this.lenses.delete(id);
  }

  get(id: string | undefined): LensDefinition | undefined {
    if (!id) return undefined;
    return this.lenses.get(id);
  }

  list(): readonly LensDefinition[] {
    return Array.from(this.lenses.values());
  }
}

export const LensRegistry = new LensRegistryImpl();

export function registerLens(lens: LensDefinition): void {
  LensRegistry.register(lens);
}
